import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/header/header";
import { RoutesPaths } from "../../Router/constant";
import { useDispatch, useSelector } from "react-redux";
import TimeFormat from "../../components/timeFormat/timeFormat";
import { getTermsAndPrivacy } from "../../actions/termsAndPrivacy";
import { PAGES } from "../../constants";

export default function TermsManager() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { termsAndPrivacy } = useSelector((state) => state.termsAndPrivacy);

  useEffect(() => {
    dispatch(getTermsAndPrivacy());
  }, [dispatch]);

  const onEdit = (value) => {
    navigate(RoutesPaths.ADDTERMSANDPRIVACY, {
      state: {
        type: value.type,
      },
    });
  };

  const shortenDescription = (description) => {
    const plainText = description.replace(/<\/?[^>]+(>|$)/g, "");
    const shortenedDescription =
      plainText.length > 100 ? plainText.substring(0, 70) + "..." : plainText;
    return shortenedDescription;
  };

  return (
    <>
      <Header title="Notification Manager" />
      <div className="container-fluid py-4">
        <div className="row">
          <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12 mb-2">
            <div className="card planList notification h-100">
              <div className="card-header">
                <div className="searchbar">
                  <h6 className="font-weight-bolder payment-text mb-0">Terms and privacy</h6>
                </div>
                <div className="filter">
                  <div className="addButton">
                    <img src="assets/img/addIcon.svg" alt="" />
                    <Link
                      to={RoutesPaths.ADDTERMSANDPRIVACY}
                      className="customAddButton"
                    >
                      Add new
                    </Link>
                  </div>
                </div>
              </div>
              <div className="card-body detail">
                <table className="businessTable">
                  <thead>
                    <tr>
                      <td>Type</td>
                      <td>Description</td>
                      <td>Action</td>
                    </tr>
                  </thead>
                  <tbody>
                    {termsAndPrivacy.length > 0 ? (
                      termsAndPrivacy?.map((ele, eleIndex) => (
                        <tr key={eleIndex}>
                          <td>
                            <h5>{parseInt(ele.type) === PAGES.PRIVACYPOLICY ? "Privacy policy" : "Terms and Conditions" || "-"}</h5>
                          </td>
                          <td className="pointer">
                            <h5 dangerouslySetInnerHTML={{ __html: shortenDescription(ele.content) }}></h5>
                          </td>
                          <td className="pointer">
                            <div className="">
                              <button
                                onClick={() => onEdit(ele)}
                                className="btn save-btn editButton editButtonTerms"
                              >
                                Edit {parseInt(ele.type) === PAGES.PRIVACYPOLICY ? "Privacy policy" : "Terms and Conditions" || "-"}
                              </button>
                            </div>
                          </td>

                        </tr>
                      ))
                    ) : (
                      <tr className="d-flex pt-3">
                        <td className="d-flex flex-column justify-content-center">
                          <h6 className="mb-0 text-sm table-heading text-center">
                            No data found
                          </h6>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
